module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko/store_images/2@2x_56b3a8b85dfd5389215476006f2f76dc.png";